export enum JackpotTypes {
  Mega = 1,
  Betshop,
  Game,
}
